import { GW_DOMAIN, API_V2 } from "@Models/GWDomain";
import axiosInstance from "./axiosInstance";

export const giftcardsBaseUrl = `${API_V2}/giftcards`;
export const promotionsBaseUrl = `${API_V2}/promotions`;
export const loungesBaseUrl = `${API_V2}/locals`;
export const cashRegisterBaseUrl = `${API_V2}/pos`;
export const billingBaseUrl = `${API_V2}/billing`;
export const servicesBaseUrl = `${API_V2}/services`;
export const productsBaseUrl = `${API_V2}/products`;
export const employeesBaseUrl = `${API_V2}/employees`;
export const supplierBaseUrl = `${API_V2}/suppliers`;
export const warehouseBaseUrl = `${API_V2}/warehouse`;
export const trackingBaseUrl = `${API_V2}/tracking`;
export const appointmentsBaseUrl = `${API_V2}/reservations`;
export const clientsBaseUrl = `${API_V2}/customers`;
export const accountBaseUrl = `${API_V2}/account`;
export const comandasBaseUrl = `${API_V2}/comandas`;

/**
 * @deprecated No usar directamente. El token ahora se obtiene dinamicamente via interceptor.
 * Mantenido solo por compatibilidad con codigo legacy que pueda importarlo.
 */
export const tokenLocal = localStorage.getItem("access_token");

/**
 * @deprecated No usar directamente. El header de autorizacion ahora se agrega
 * automaticamente via interceptor en cada request.
 * Mantenido solo por compatibilidad con codigo legacy que pueda importarlo.
 */
export const headerAuthorization = {
  headers: {
    Authorization: `Bearer ${tokenLocal}`,
  },
};
export interface ApiResponse {
  isSuccess: boolean;
  status: number;
  data: any;
  message: string;
}

export const handleSuccessfulResponse = (
  response: any,
  successMessage?: string
): ApiResponse => ({
  isSuccess: true,
  status: response.status,
  data: response.data.data,
  message: response?.data?.message || successMessage,
});

export const handleApiError = (
  error: any,
  errorMessage?: string
): ApiResponse => {
  const status = error.response ? error.response.status : 500;
  return {
    isSuccess: false,
    status: error?.response?.status || 500,
    data: null,
    message: error?.response?.data?.message || errorMessage,
  };
};
/**
 * Realiza una peticion GET usando la instancia de axios configurada.
 * El token de autorizacion se obtiene dinamicamente del localStorage en cada request.
 */
export const getData = async (
  url: string,
  successMessage?: string,
  errorMessage?: string
): Promise<ApiResponse> => {
  try {
    const response = await axiosInstance.get(url);
    return handleSuccessfulResponse(response, successMessage);
  } catch (error) {
    return handleApiError(error, errorMessage);
  }
};

/**
 * Realiza una peticion POST usando la instancia de axios configurada.
 * El token de autorizacion se obtiene dinamicamente del localStorage en cada request.
 */
export const postData = async (
  url: string,
  data: any,
  successMessage?: string,
  errorMessage?: string
): Promise<ApiResponse> => {
  try {
    const response = await axiosInstance.post(url, data);
    return handleSuccessfulResponse(response, successMessage);
  } catch (error) {
    return handleApiError(error, errorMessage);
  }
};

/**
 * Realiza una peticion PUT usando la instancia de axios configurada.
 * El token de autorizacion se obtiene dinamicamente del localStorage en cada request.
 */
export const putData = async (
  url: string,
  data: any,
  successMessage?: string,
  errorMessage?: string
): Promise<ApiResponse> => {
  try {
    const response = await axiosInstance.put(url, data);
    return handleSuccessfulResponse(response, successMessage);
  } catch (error) {
    return handleApiError(error, errorMessage);
  }
};

/**
 * Realiza una peticion DELETE usando la instancia de axios configurada.
 * El token de autorizacion se obtiene dinamicamente del localStorage en cada request.
 */
export const deleteData = async (
  url: string,
  successMessage?: string,
  errorMessage?: string
): Promise<ApiResponse> => {
  try {
    const response = await axiosInstance.delete(url);
    return handleSuccessfulResponse(response, successMessage);
  } catch (error) {
    return handleApiError(error, errorMessage);
  }
};
